import React, { FC } from "react";
import useTranslation from "next-translate/useTranslation";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";
import { Accordion } from "@/components/Accordion";

type IFigmaBackupFaqSection = {
  translationNamespace?: string;
};

export const BackupFaqSection: FC<IFigmaBackupFaqSection> = ({
  translationNamespace = "section/figmaBackupFaq",
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();
  const { t } = useTranslation(translationNamespace);

  return (
    <Grid
      customStyle={{
        flexDirection: "column",
        [bp.FROM_DESKTOP]: {
          padding: "56px 20px 36px",
        },
      }}
      id="FigmaBackupFaqSection"
    >
      <Heading
        as="h2"
        customStyle={{ color: colors.CHARCOAL, textAlign: "center" }}
      >
        {t("title")}
      </Heading>
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          [bp.FROM_TABLET]: {
            flexDirection: "row",
          },
        })}
      >
        <div
          className={css({
            width: "100%",
            [bp.FROM_TABLET]: {
              width: "calc(50% - 21px)",
              display: "inline-block",
              marginRight: 21,
            },
          })}
        >
          <Accordion
            title={t("whyBackup.question")}
            longAnswer={t("whyBackup.answer")}
          />
          <Accordion
            title={t("backupDuration.question")}
            longAnswer={t("backupDuration.answer")}
          />
          <Accordion
            title={t("howToRestore.question")}
            longAnswer={t("howToRestore.answer")}
          />
          <Accordion
            title={t("areFilesSecure.question")}
            longAnswer={t("areFilesSecure.answer")}
          />
        </div>
        <div
          className={css({
            width: "100%",
            [bp.FROM_TABLET]: {
              width: "calc(50% - 21px)",
              display: "inline-block",
            },
          })}
        >
          <Accordion
            title={t("backupCycleDuration.question")}
            longAnswer={t("backupCycleDuration.answer")}
          />
          <Accordion
            title={t("trial.question")}
            longAnswer={t("trial.answer")}
          />
          <Accordion
            title={t("customStorage.question")}
            longAnswer={t("customStorage.answer")}
          />
          <Accordion
            title={t("figjam.question")}
            longAnswer={t("figjam.answer")}
          />
        </div>
      </div>
    </Grid>
  );
};
